module.exports = __webpack_public_path__ + "static/media/school_rep.d5e70aed.png";